import 'slick-carousel'
import 'slick-lightbox'
import 'bootstrap-datepicker'
import Plyr from 'plyr'
import Cookies from 'js-cookie'
import moment from 'moment'
import Rellax from 'rellax'

import { gsap } from 'gsap' // Import GSAP library

import { ScrollTrigger } from 'gsap/ScrollTrigger' // Import ScrollTrigger plugin

gsap.registerPlugin(ScrollTrigger) // Register ScrollTrigger plugin

const digistormWeb = {
    init() {
        // helper for iOS issues
        this.iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)

        // load nav
        this.nav()

        // load tabs
        this.tabs()
        this.accordions()

        // load videos
        this.videos.init()

        // load carousel
        this.slick()
        this.banners()
        this.video_modal()
        this.playerinline()
        this.forms()

        this.popups()
        this.analytics()

        this.employment()

        this.newsletters()

        this.entryScreen()

        this.socialFeeds()
        this.newsletterBackToTop()

        this.wowo()
        this.stickyMenu()
        this.navbar()
        this.search()
        this.googleTranslate()
        this.alertBar()
        this.verticalLineEffect()
        this.singleVideo()
        this.hozaccordion()
        this.animatedIconsBgChange()
        this.horizontalScrollTiles()
        this.newsEvents()
        this.staffDirectory()
        this.pallaraxContents()
        this.entryCalculator()
        this.customSelect()
    },

    newsletterBackToTop() {
        $('.back-top').on('click', () => {
            $('#main').scrollIntoView({ behavior: 'smooth', block: 'start' })
        })
    },

    socialFeeds() {
        $('section.social-block').each(function () {
            // console.log("requesting social posts...");
            const socialWrapper = $(this).find('.social-wrapper')

            //   this is the toggle for individual social blocks
            const facebookToggle = $(this).attr('data-facebook') === '1'
            const instagramToggle = $(this).attr('data-instagram') === '1'
            const limit = 4

            const svgMap = {
                facebook: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 512"><path d="M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229"/></svg>
  `,
                instagram: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg>
  `,
            }

            $.ajax({
                url: '/api/socialfeed/request-posts',
                data: {
                    facebook: facebookToggle,
                    instagram: instagramToggle,
                    limit,
                },
                dataType: 'json',
                success(posts) {
                    // console.log("...successfully fetched social posts");
                    let postHtml = ''

                    $.each(posts, (index, post) => {
                        const postDescription =
                            post.description.length > 200
                                ? `${post.description.substring(0, 199).trim()}...`
                                : post.description
                        const date = new Date(post.created * 1000).toLocaleDateString()

                        let iconSvg = ''
                        if (post.type in svgMap) {
                            iconSvg = svgMap[post.type]
                        }

                        // append post html
                        postHtml += `
                            <a class="social-tile" href="${post.link}" target="_blank">
                                <img src="${post.image}" />
                                <span class="social-icon">
                                  ${iconSvg}
                                </span>
                                <div class="content">
                                    <p>${postDescription}</p>
                                    <span>VIEW MORE</span>
                                </div>
                            </a>`
                    })

                    // render posts on page
                    socialWrapper.html(postHtml)

                    // call slick slider events
                    socialWrapper.slick({
                        arrows: false,
                        dots: false,
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        gutter: 120,
                        responsive: [
                            {
                                breakpoint: 1023,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                    infinite: true,
                                },
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    infinite: true,
                                    centerMode: true,
                                },
                            },
                        ],
                    })
                },
            }).fail(() => {
                console.log('...failed fetching social posts')
                socialWrapper
                    .find('.socials-loading')
                    .html('<h5>Something went wrong when fetching social feed.<br>Please try again later!</h5>')
            })
        })
    },

    entryScreen() {
        const es = $('.entry-screen')

        const key = 'entryScreen'

        const cookie = Cookies.get(key)

        if (!cookie) {
            es.css('display', 'flex')
            setTimeout(() => {
                es.addClass('change-bg')
                setTimeout(() => {
                    es.addClass('active')
                }, 900)
            }, 2000)
            Cookies.set(key, 'viewed', { expires: 1 })
        }
    },

    banners() {
        const banner = $('.image-carousel .slick-content')
        if (banner.length > 0) {
            banner.slick({
                dots: banner.find('.banner-inner').length > 1,
                arrows: false,
                infinite: true, // loop
                speed: 800,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 6000,
                focusOnSelect: true,
                pauseOnHover: false, // mouse hover
                lazyLoad: 'anticipated',
            })
            banner.removeClass('init')
        }
    },

    nav() {
        // find any navbar burger buttons
        $('.navigation')
            .find('.navbar-burger')
            .click(function (e) {
                e.preventDefault()

                // find specified navbar
                const target = $(this).attr('data-target')

                if (target.length) {
                    // toggle active class on burger button
                    $('.navbar-burger').toggleClass('is-active')

                    // toggle active class on specified menu
                    $(`#${target}`).toggleClass('is-active')

                    if (!$(this).hasClass('is-active')) {
                        $('.top-level-item.has-children.is-active').removeClass('is-active')
                    }
                }
            })
        if (window.innerWidth <= 1024) {
            $('.navbar-menu .top-level-item.has-children .view-children').on('click', function () {
                const parent = $(this).closest('.top-level-item')
                parent.addClass('is-active').siblings('.top-level-item.has-children').removeClass('is-active')
            })

            $('.navbar-menu .child-item.has-third .view-children-child').on('click', function () {
                const parent = $(this).closest('.child-item')
                parent.addClass('is-active').siblings('.child-item.has-third').removeClass('is-active')
            })

            $('.navbar-menu .children-panel .subpage-close').on('click', () => {
                $('.top-level-item.has-children.is-active').removeClass('is-active')
            })

            $('.navbar-menu .children-panel .subpage-close-third').on('click', () => {
                $('.child-item.has-third.is-active').removeClass('is-active')
            })
        } else {
            $('.navbar-menu .top-level-item.has-children').on('mouseenter', function () {
                const parent = $(this).closest('.top-level-item')
                $('.navbar-menu .child-item.has-third').removeClass('is-active')
                parent.addClass('is-active').siblings('.top-level-item.has-children').removeClass('is-active')
            })

            $('.navbar-menu .top-level-item').on('mouseenter', function () {
                const self = $(this).closest('.top-level-item')
                self.removeClass('is-faded').siblings('.top-level-item').addClass('is-faded')
            })

            $('.navbar-menu .child-item').on('mouseenter', () => {
                $('.navbar-menu .child-item.has-third').removeClass('is-active')
            })

            $('.navbar-menu .child-item.has-third').on('mouseenter', function () {
                const parent = $(this).closest('.child-item')
                $('.navbar-menu .child-item.has-third').removeClass('is-active')
                parent.addClass('is-active').siblings('.child-item.has-third').removeClass('is-active')
            })
        }

        $('.quicklinks .link-title').on('click', function () {
            const parent = $(this).parent('.quicklinks')
            parent.toggleClass('is-active')

            if (parent.hasClass('is-active')) {
                setTimeout(() => {
                    parent[0].scrollIntoView({ behavior: 'smooth', block: 'end' })
                }, 500)
            }
        })

        $('.side-quicklinks').on('click', function () {
            $(this).toggleClass('is-active')
            $('#side-quicklinks-close').toggleClass('is-active')
        })

        $('#side-quicklinks-close').on('click', function () {
            $(this).toggleClass('is-active')
            $('.side-quicklinks').toggleClass('is-active')
        })

        // find any navbar search buttons
        // $('.navigation .search-trigger').click(function (e) {
        //     e.preventDefault()
        //
        //     // find specified navbar
        //     const target = $(this).attr('data-target')
        //
        //     if (target.length) {
        //         // toggle active class on specified element
        //         $(`#${ target}`).toggleClass('is-active')
        //
        //         if ($(`#${ target}`).is('.is-active')) {
        //             $('input.search').focus()
        //         } else {
        //             $('input.search').blur()
        //         }
        //     }
        // })
    },

    video_modal() {
        $('.play-video-btn').on('click', function (e) {
            e.preventDefault()
            const modalId = $(this).attr('data-modal-id')
            const modal = $(`#${modalId}`)

            if (!modal) {
                return
            }

            const videoPlayer = modal.find('.video-player')
            if (!videoPlayer) {
                return
            }

            if (!videoPlayer.hasClass('plyr-loaded')) {
                digistormWeb.videos.loadVideoModal(videoPlayer[0])
            } else {
                const settings = JSON.parse(videoPlayer.attr('data-settings'))
                digistormWeb.videos.playVideo(videoPlayer, settings.volume, settings.muted)
            }

            modal.addClass('is-active')
        })

        $('.video-modal .modal-background').click(function () {
            const $modal = $(this).closest('.video-modal')
            $modal.removeClass('is-active')
            if (digistormWeb.iOS) {
                digistormWeb.videos.stopVideo($modal.find('.video-player'))
            } else {
                digistormWeb.videos.pauseVideo($modal.find('.video-player'))
            }
        })

        $('.video-modal .close-modal').click(function (e) {
            e.preventDefault()
            const $modal = $(this).closest('.video-modal')
            $modal.removeClass('is-active')
            digistormWeb.videos.stopVideo($modal.find('.video-player'))
        })
    },
    playerinline() {
        // Play video
        $('.video-player.inline').each(function () {
            const videoPlayer1 = $(this)
            if (!videoPlayer1) return

            if (!videoPlayer1.hasClass('plyr-loaded')) {
                // console.log(videoPlayer1);
                digistormWeb.videos.loadVideoModal(videoPlayer1)
            } else {
                // console.log('not loaded');
                digistormWeb.videos.playVideo(videoPlayer1)
                // var settings = JSON.parse(videoPlayer.attr('data-settings'));
                // console.log(settings);
                // digistormWeb.videos.playVideo(videoPlayer, settings.volume, settings.muted);
            }
        })
    },
    videos: {
        init() {
            const _self = this

            // check if there is a video player wrapper

            if ($('.video-player.banner-video').length) {
                $('.video-player.banner-video').each(function () {
                    _self.loadVideo(this)
                })
            }

            _self.controls()
            _self.carousel()
        },

        controls() {
            // initialise video controls

            $('.video-carousel .banner .control-pause').click(function () {
                const $player = $(this).closest('.banner').find('.video-player')
                switch (digistormWeb.videos.togglePlay($player)) {
                    case 'no-data':
                        break
                    case true:
                        $(this).removeClass('fa-play').addClass('fa-pause')
                        break
                    case false:
                        $(this).removeClass('fa-pause').addClass('fa-play')
                        break
                }
            })

            $('.video-carousel .banner .control-vol').click(function () {
                const $player = $(this).closest('.banner').find('.video-player')
                switch (digistormWeb.videos.toggleMute($player)) {
                    case 'no-data':
                        break
                    case true:
                        $(this).removeClass('fa-volume-off').addClass('fa-volume-up')
                        break
                    case false:
                        $(this).removeClass('fa-volume-up').addClass('fa-volume-off')
                        break
                }
            })
        },

        carousel() {
            // handle videos inside slick carousels
            $('.video-carousel')
                .on('init', (event, slick) => {
                    // mark carousel as initialized
                    slick.is_initialized = true
                })
                .on('setPosition', (event, slick) => {
                    // synchronize slides with videos

                    if (slick.is_initialized) {
                        // the slide up next
                        const $newSlide = $(slick.$slides[slick.currentSlide])

                        // pause others
                        $newSlide
                            .closest('.video-carousel')
                            .find('.banner')
                            .not($newSlide)
                            .find('.video-player')
                            .each((i, e) => {
                                if (digistormWeb.iOS) {
                                    // currently there's a bug with plyr where pause won't work on iOS
                                    digistormWeb.videos.stopVideo($(e))
                                } else {
                                    digistormWeb.videos.pauseVideo($(e))
                                }
                            })

                        // play new slide
                        const video = $newSlide.find('.video-player')
                        digistormWeb.videos.playVideo(video)
                        if (video.data() && video.data().player) {
                            // This slide is a video, pause slick autoslide
                            slick.$slider.slick('slickPause')
                        } else {
                            // This slide is not a video, resume slick autoslide
                            slick.$slider.slick('slickPlay')
                            $('.circleProgress').css('animation-duration', `${5.9}s`)
                        }
                    }
                })
        },

        loadVideo(el) {
            // load a video element

            // get each config attr from this element
            const settings = JSON.parse($(el).attr('data-settings'))

            // grab player elements
            const player = $(el).find('.player')

            const plyr = new Plyr(player[0], settings)
            // set up each video
            $(el).data({
                player: plyr,
            })

            // if a carousel video, go to the next slide on video end
            const $carousel = $(el).closest('.video-carousel')
            if ($carousel.length) {
                if (plyr.source && plyr.source.indexOf('youtube') >= 0) {
                    // youtube loop doesn't work, manually detect end of video
                    plyr.on('timeupdate', (event) => {
                        if (plyr.currentTime >= plyr.duration - 0.1) {
                            plyr.restart()
                            if ($carousel.find('.banner').length > 1) {
                                $carousel.slick('slickNext')
                            }
                        }
                    })
                } else {
                    // on loop, go to the next slide
                    plyr.on('seeked', (event) => {
                        $carousel.slick('slickNext')
                    })
                }

                plyr.on('playing', () => {
                    $(el).closest('.banner').find('.control-pause').removeClass('fa-play').addClass('fa-pause')
                })
                plyr.on('pause', () => {
                    $(el).closest('.banner').find('.control-pause').removeClass('fa-play').addClass('fa-pause')
                })
            }

            if (settings.muted && settings.autoplay) {
                digistormWeb.videos.attemptPlay(plyr)
            }
        },

        loadVideoModal(el) {
            // console.log("loading video now");

            // get each config attr from this element
            const settings = JSON.parse($(el).attr('data-settings'))

            // grab player elements
            const player = $(el).find('.player')

            const plyr = new Plyr(player[0], settings)

            // set up each video
            $(el).data({
                player: plyr,
            })

            digistormWeb.videos.attemptPlay(plyr, settings.volume, settings.muted)

            $(el).addClass('plyr-loaded')
        },

        attemptPlay(player, volume = 0, muted = true, count = 0) {
            // attempts to play the video multiple times in case element is still loading

            player.volume = volume
            player.muted = muted
            player.play()
            if (count < 15 && !player.playing) {
                setTimeout(() => {
                    count++
                    digistormWeb.videos.attemptPlay(player, volume, muted, count)
                }, 1000)
            }
        },

        playVideo($el, volume = 0, muted = 1) {
            if ($el.data() && $el.data().player) {
                // enable ability to play unmuted
                $el.data().player.volume = volume
                $el.data().player.muted = muted
                $el.data().player.play()
            }
        },
        pauseVideo($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.pause()
            }
        },
        stopVideo($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.stop()
            }
        },
        togglePlay($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.togglePlay()
                return $el.data().player.playing
            }
            return 'no-data'
        },
        toggleMute($el) {
            if ($el.data() && $el.data().player) {
                const player = $el.data().player
                if (player.volume === 0) {
                    player.volume = 1
                    return true
                }
                player.volume = 0
                return false
            }
            return 'no-data'
        },
    },

    slick() {
        $('.home-banners').each(function () {
            const $dotswrapper = $(this).parent().find('.slick-dots-wrapper .container')
            const $slickElement = $(this)
            $slickElement.slick({
                arrows: false,
                dots: false,
            })
        })

        function initializeSlick() {
            $('.fullwidth-image-animated-icons-block').each(function () {
                const $prevArrow = $('.fullwidth-image-animated-icons-block').find('.slick-arrows-wrapper .slick-prev')
                const $nextArrow = $('.fullwidth-image-animated-icons-block').find('.slick-arrows-wrapper .slick-next')
                if ($(window).width() <= 1023) {
                    const $slickElement = $(this).find('.animated-slides-wrapper')
                    $slickElement.slick({
                        arrows: true,
                        prevArrow: $prevArrow,
                        nextArrow: $nextArrow,
                        dots: false,
                    })
                }
            })
        }

        initializeSlick()

        $(window).resize(() => {
            initializeSlick()
            console.log('resizing')
        })

        // load basic slick on all basic slicks
        $('.gallery.is-carousel').each(function () {
            const _self = this
            const $prevArrow = $(this).find('.slick-arrows-wrapper .slick-prev')
            const $nextArrow = $(this).find('.slick-arrows-wrapper .slick-next')
            const $slideIndex = $(this).find('.current-slide')

            $(this)
                .find('.slick')
                .slick({
                    dots: false,
                    arrows: true,
                    prevArrow: $prevArrow,
                    nextArrow: $nextArrow,
                    infinite: true,
                })
                .on('afterChange', (event, slick, currentSlide) => {
                    const $currentSlide = $(slick.$slides[currentSlide])
                    const dataIndex = $currentSlide.data('slick-index') + 1
                    $slideIndex.text(dataIndex < 10 ? `0${dataIndex}` : dataIndex)
                })
        })

        // lightbox config
        $('.gallery.is-carousel')
            .find('.slick')
            .slickLightbox({
                src: 'src',
                itemSelector: 'img',
                caption: 'caption',
                layouts: {
                    closeButton:
                        '<a href="#" class="close-modal slick-lightbox-close"> <span></span> <span></span> <span></span> </a>',
                },
            })

        const galleryLightbox = $('.gallery.is-lightbox')
            .find('ul')
            .slickLightbox({
                itemSelector: '> li > a',
                caption: 'caption',
                layouts: {
                    closeButton:
                        '<a href="#" class="close-modal slick-lightbox-close"> <span></span> <span></span> <span></span> </a>',
                },
            })
        galleryLightbox.on({
            'show.slickLightbox': function () {
                digistormWeb.lockBg()
            },
            'shown.slickLightbox': function () {
                // fired when the lightbox is opened, after the transitions took place
            },
            'hide.slickLightbox': function () {
                // fired when the lightbox is closed
                digistormWeb.unlockBg()
            },
            'hidden.slickLightbox': function () {
                // fired when the lightbox is closed, after the transitions took place
            },
        })

        $('.gallery.is-lightbox .more-s').click(function (e) {
            e.preventDefault()
            $(this).closest('.is-lightbox').find('.is-hidden:first a').click()
        })

        const newsEventsCarousel = $('.news-and-events-block .news-wrapper')
        newsEventsCarousel.each(function () {
            const $slickElement = $(this).find('.slick-wrapper')
            const $prevArrow = $('.news-and-events-block').find('.slick-arrows-wrapper .slick-prev')
            const $nextArrow = $('.news-and-events-block').find('.slick-arrows-wrapper .slick-next')

            $slickElement.slick({
                arrows: true,
                dots: false,
                prevArrow: $prevArrow,
                nextArrow: $nextArrow,
                variableWidth: false,
                infinite: true,
                speed: 300,
                autoplay: false,
                autoplaySpeed: 5000,
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: false,
                responsive: [
                    {
                        breakpoint: 5000,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 1023,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            variableWidth: true,
                            centerMode: true,
                        },
                    },
                ],
            })
        })
    },

    tabs() {
        const _self = this

        // transform tabs into work of magic
        $('.tabs.style-standard')
            .find('.tab-title')
            .click(function () {
                // get the relative tabs
                const $tabs = $(this).closest('.tabs')
                const activeIndex = $(this).index()

                // remove active class from all tabs
                $tabs.find('.tab-title').removeClass('is-active')
                $tabs.find('.tab-content').removeClass('is-active')

                // add active to current tab
                $(this).addClass('is-active')
                $tabs.find('.tab-content').eq(activeIndex).addClass('is-active')
            })
    },

    accordions() {
        $('.tabs.style-accordion').each(function () {
            const $group = $(this)

            $('.accordion-wrapper .accordion-header', $group).click(function () {
                const $wrapper = $(this).closest('.accordion-wrapper')

                $wrapper.toggleClass('is-active')
            })
        })
    },

    forms() {
        // Send google analytics event on form submission
        $('[data-form-name] form').submit(function () {
            const formWrapper = $(this).closest('[data-form-name]')
            if (window.ga) {
                ga('send', 'event', formWrapper.attr('data-form-name'), formWrapper.attr('data-form-page'))
            }
        })
    },

    popups() {
        $('.action-modal').each(function () {
            const modal = $(this)
            const key = `modal-${modal.data('key')}`
            const cookie = Cookies.get(key)

            if (!cookie) {
                modal.addClass('active')
                $('#page-container').addClass('action-modal-active')

                const image = modal.find('img')
                const imageHeight = image.outerHeight()
                // $('#page-container').css('paddingTop', imageHeight)
                image.on('load', function () {
                    const imageHeight = this.outerHeight()
                    // $('#page-container').css('paddingTop', imageHeight)
                })
                $(window).on('resize', () => {
                    const imageHeight = image.outerHeight()
                    // $('#page-container').css('paddingTop', imageHeight)
                })

                modal.find('.close-action-modal').click(() => {
                    modal.addClass('delete')
                    modal.removeClass('active')
                    $('#page-container').removeClass('action-modal-active')
                    Cookies.set(key, 'viewed', { expires: 5 })
                })
                modal.find('.action-modal-background').click(() => {
                    modal.removeClass('active')
                })
            }
        })
    },

    analytics() {
        // Track clicks on external links
        $('body').on('click', 'a[href]', function (e) {
            const domain = String(window.location.host).replace(/^www\./, '')
            const openInNewWindow = $(this).attr('target') === '_blank'
            const url = $(this).attr('href')

            // Find the domain of the link. Works with http, https and protocol-less urls
            const linkAnatomy = url.match(/^(https?:)?\/\/(www\.)?([^/\s]+)/)
            if (linkAnatomy) {
                const linkDomain = linkAnatomy[3]

                // Check if google analytics is loaded and the url is external
                if (window.ga && domain !== linkDomain) {
                    ga('send', 'event', 'Navigation', 'Open URL', url)

                    // If the link will open in this window we should delay navigation until the event is sent
                    if (!openInNewWindow && !e.isDefaultPrevented()) {
                        e.preventDefault()

                        // Push the navigation onto the queue (will be processed after event is sent)
                        ga(() => {
                            // Navigate to url
                            window.location.href = url
                        })

                        return false
                    }
                }
            }
        })
    },
    employment() {
        $('.application-form').each((i, e) => {
            const $form = $(e)
            const jobTitle = $form.data('job-title')
            $form.find('input.positionAppliedFor').val(jobTitle)
        })
    },
    newsletters() {
        // Newsletter section

        $('.newsletter-article')
            .find('.continue')
            .on('click', function (e) {
                const $article = $(this).parent()
                const $expandable = $article.find('.newsletter-blocks-wrapper')
                const $content = $article.find('.newsletter-blocks')

                // toggle class
                $article.toggleClass('is-active')

                // set height to article size
                const height = $content.outerHeight() + 20
                $expandable.css({ 'max-height': `${height}px` })

                if ($article.hasClass('is-active')) {
                    // allow any height after animation done
                    setTimeout(() => {
                        if ($article.hasClass('is-active')) {
                            $expandable.css({ 'max-height': 'none' })
                        }
                    }, 300)
                } else {
                    // if collapsing article set max height
                    setTimeout(() => {
                        if (!$article.hasClass('is-active')) {
                            $expandable.css({ 'max-height': '0' })
                        }
                    }, 100)
                }
            })

        $('.newsletter-sidebar #newsletter-menu').on('click', function (e) {
            const menuparent = $(this).closest('.newsletter-sidebar')
            if (!menuparent.hasClass('is-active')) {
                menuparent.addClass('is-active')
            } else {
                menuparent.removeClass('is-active')
            }
        })

        $('.newsletter-sidebar .category-heading').click(function () {
            const target = $($(this).attr('data-attr'))
            $('html, body').animate(
                {
                    scrollTop: target.offset().top - 200,
                },
                800
            )
            const windowWidth = $(window).width()
            if (windowWidth < 1023) {
                $('.toggle-nav-newsletter').toggleClass('cross')
                $('.newsletter-sidebar').toggleClass('open-sidenav')
            }
        })
    },
    entryCalculator() {
        /* Prep Calculator --------------------- */
        function calculateEnrol(birthYear, birthMonth) {
            // QLD kids start Pre prep at 4 years old, so add 4 to the year they were born
            let startYear = birthYear + 4
            const yearLevels = [
                'Pre Prep',
                'Prep',
                'Year 1',
                'Year 2',
                'Year 3',
                'Year 4',
                'Year 5',
                'Year 6',
                'Year 7',
                'Year 8',
                'Year 9',
                'Year 10',
                'Year 11',
                'Year 12',
            ]
            // students born after june get pushed forward a year
            if (birthMonth > 6) {
                startYear++
            }
            const $resultsContainer = $('.child-results')
            const $resultsTable = $resultsContainer.find('table')
            let resultsHtml = '<tr><th>Year of Entry</th><th>Year</th></tr>'
            for (let i = 0; i < yearLevels.length; i++) {
                if (yearLevels[i] === 'Prep' || yearLevels[i] === 'Year 7') {
                    resultsHtml = `${resultsHtml}<tr><td>${startYear}</td><td>${yearLevels[i]}</td>`
                }
                startYear++
            }
            // clear table and render results
            $resultsContainer.show()
            $resultsTable.html('').append(resultsHtml)
        }
        // init datepicker
        const $datepicker = $('.input-group.date')
        $datepicker.datepicker({
            container: '.picker-container',
            startDate: `01/01/${new Date().getFullYear() - 15}`,
            startView: '2',
            autoclose: true,
            todayHighlight: true,
            format: 'dd/mm/yyyy',
        })
        // listen for datepicker change
        $datepicker.datepicker().on('changeDate', (e) => {
            const childBirthday = moment($datepicker.datepicker('getDate'))
            calculateEnrol(childBirthday.year(), childBirthday.month() + 1)
        })
        /* End Prep Calculator --------------------- */
    },
    lockBg() {
        // lock window position
        document.documentElement.style.overflow = 'hidden'
        document.body.scroll = 'no'
    },
    unlockBg() {
        // unlock window position
        document.documentElement.style.overflow = 'scroll'
        document.body.scroll = 'yes'
    },

    wowo() {
        const wTop = $(window).scrollTop()
        const wHeight = $(window).height()
        const wBottom = wTop + wHeight
        $('.wowo:not(.animated)').each(function () {
            const me = $(this)
            const meTop = me.offset().top
            const meHeight = me.innerHeight()
            const meBottom = meTop + meHeight
            const limitTop = wTop - meHeight
            const limitBottom = wBottom + meHeight
            if (meTop > limitTop && meBottom < limitBottom) {
                me.addClass('animated')
                setTimeout(() => {
                    me.removeClass('wowo')
                }, 1500)
            }
        })
    },

    customSelect() {
        // custom select box for home tabs on mobile/tablet
        $('.custom-select').each(function () {
            const $styledSelect = $(this).find('.select-styled')
            const $styledSelectSpan = $(this).find('.select-styled span')
            const $list = $(this).find('.select-options')
            const $listItems = $(this).find('.select-options li')

            $styledSelect.click(function (e) {
                e.stopPropagation()
                $('div.select-styled.active')
                    .not(this)
                    .each(function () {
                        $(this).removeClass('active').next('ul.select-options').hide()
                    })
                $(this).toggleClass('active').next('ul.select-options').toggle()
            })

            $listItems.click(function (e) {
                e.stopPropagation()
                $styledSelectSpan.text($(this).text()).removeClass('active')
                $styledSelect.attr('value', $(this).attr('rel'))
                $list.hide()
            })

            $(document).click(() => {
                $styledSelect.removeClass('active')
                $list.hide()
            })
        })
    },

    userback() {
        // const cookieValue = document.cookie
        //     .split('; ')
        //     .find((row) => row.startsWith('adminUserGroup='))
        //     ?.split('=')[1]
        // if (cookieValue === 1) {
        // console.log(cookieValue);
        window.Userback = window.Userback || {}
        Userback.access_token = 'A-KAOWMJMCCue19JyPCT444tKeu'
        ;(function (d) {
            const s = d.createElement('script')
            s.async = true
            s.src = 'https://static.userback.io/widget/v1.js'
            ;(d.head || d.body).appendChild(s)
        })(document)
        // }
    },

    stickyMenu() {
        if ($('.navigation').length) {
            const { body } = document
            const nav = document.querySelector('.navigation')
            const scrollUp = 'menu-stuck'
            const scrollUpNav = 'is-stuck'
            const scrollDown = 'scroll-down'
            let lastScroll = 0

            let width = $(document).width()
            let navOffset = 95

            window.addEventListener('resize', () => {
                width = $(window).width()
            })

            window.addEventListener('scroll', () => {
                const currentScroll = window.pageYOffset
                const scrollLimit = 0
                const scrollValue = window.scrollY

                if ($('body').hasClass('autoscroll')) {
                    return
                }

                if (width <= 1023) {
                    navOffset = 81
                } else if (width < 1215) {
                    navOffset = 140
                } else {
                    navOffset = 161
                }

                // console.log({scrollValue, lastScroll, width, currentScroll, navOffset})

                if (scrollValue >= scrollLimit) {
                    if (currentScroll <= navOffset) {
                        body.classList.remove(scrollUp)
                        body.classList.remove(scrollDown)
                        nav.classList.remove(scrollUpNav)
                        return
                    }
                    if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
                        // down
                        body.classList.remove(scrollUp)
                        nav.classList.remove(scrollUpNav)
                        body.classList.add(scrollDown)
                    } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
                        // up
                        body.classList.remove(scrollDown)
                        body.classList.add(scrollUp)
                        nav.classList.add(scrollUpNav)
                    }
                    lastScroll = currentScroll
                }
            })
        }
    },
    lockScroll() {
        const $html = $('html')
        const $body = $('body')
        const initWidth = $body.outerWidth()
        const initHeight = $body.outerHeight()

        const scrollPosition = [
            self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
            self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop,
        ]
        $html.data('scroll-position', scrollPosition)
        $html.data('previous-overflow', $html.css('overflow'))
        $html.css('overflow', 'hidden')
        window.scrollTo(scrollPosition[0], scrollPosition[1])

        const marginR = $body.outerWidth() - initWidth
        const marginB = $body.outerHeight() - initHeight
        $body.css({
            'margin-right': marginR,
            'margin-bottom': marginB,
        })
    },
    unlockScroll() {
        const $html = $('html')
        const $body = $('body')
        $html.css('overflow', $html.data('previous-overflow'))
        const scrollPosition = $html.data('scroll-position')
        window.scrollTo(scrollPosition[0], scrollPosition[1])

        $body.css({ 'margin-right': 0, 'margin-bottom': 0 })
    },
    navbar() {
        $('.navigation')
            .find('.navbar-burger')
            .on('click', function (e) {
                e.preventDefault()
                const target = $(this).attr('data-target')
                const targetObj = $(`#${target}`)
                const object = $('body')
                if (!object.hasClass('menu-open')) {
                    $(object).addClass('menu-open')
                    targetObj.addClass('is-active')

                    $('.menu-text').addClass('is-active')

                    // console.log(target);
                    digistormWeb.lockScroll()
                } else {
                    $(object).removeClass('menu-open')
                    targetObj.removeClass('is-active')
                    digistormWeb.unlockScroll()
                    $('.menu-text').removeClass('is-active')
                }
            })

        $('.nav-overlay').on('click', () => {
            $('body').removeClass('menu-open')
            $('.offcanvas-trigger').removeClass('is-active')
            $('.offcanvas-navbar').removeClass('is-active')
            digistormWeb.unlockScroll()
        })

        $('.navbar-dropdown, .navbar-dropdown-third').on('click', (e) => {
            e.stopPropagation()
        })
        $('.nav-lower .quick-links .list-heading').on('click', function (e) {
            const menuparent = $(this).closest('.nav-lower')
            if (!menuparent.hasClass('is-active')) {
                menuparent.addClass('is-active')
            } else {
                menuparent.removeClass('is-active')
            }
        })

        $('.nav-menu-drowpdown-title').on('click', function () {
            $(this).toggleClass('is-active')
            $(this).next().toggleClass('is-active')
        })

        $(document).on('click', (event) => {
            if (!$(event.target).closest('.nav-menu-drowpdown-title, .nav-menu-drowpdown-links').length) {
                $('.nav-menu-drowpdown-title').removeClass('is-active')
                $('.nav-menu-drowpdown-title').next().removeClass('is-active')
            }
        })

        $('.mobile-navbar-buttons .subpage-close svg').on('click', () => {
            $('.mobile-navbar-buttons .nav-menu-drowpdown-links').removeClass('is-active')
        })
    },
    search() {
        $('.search-trigger').on('click', (e) => {
            e.preventDefault()

            digistormWeb.lockScroll()

            $('#search-box').stop().fadeIn(300).addClass('show-it')
            const sTime = setTimeout(() => {
                $('body').stop().addClass('modal-open-search')
                $('#search-box').find('.input').stop().focus()
            }, 900)
        })
        $('#search-close').on('click', () => {
            // clearTimeout(sTime);
            $('.modal-open-search').removeClass('modal-open-search')
            digistormWeb.unlockScroll()
            $('#search-box').stop().fadeOut(300).removeClass('show-it')
            $('#search-box').find('.input').stop().blur()
        })
    },
    googleTranslate() {
        window.googleTranslateElementInit = function () {
            const { includedLanguages } = document.getElementById('google-translate-element').dataset

            const googleTranslate = new google.translate.TranslateElement(
                {
                    pageLanguage: 'en',
                    includedLanguages,
                    layout: google.translate.TranslateElement.InlineLayout.VERTICAL,
                    autoDisplay: true,
                },
                'google-translate-element'
            )
        }

        // Load the Google Translate script
        const script = document.createElement('script')
        script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
        document.head.appendChild(script)
    },
    alertBar() {
        $('.alert-bar').each(function () {
            const modal = $(this)
            const key = `modal-${modal.data('key')}`
            const cookie = Cookies.get(key)

            if (!cookie) {
                modal.addClass('active')
                $('#ds-vue-wrapper').addClass('alert-bar-active')

                modal.find('.close-alert-bar').on('click', () => {
                    modal.addClass('delete')
                    $('#ds-vue-wrapper').removeClass('alert-bar-active')
                    Cookies.set(key, 'viewed', {
                        expires: 5,
                    })
                    setTimeout(() => {
                        modal.removeClass('active')
                    }, 300)
                })
                modal.find('.alert-bar-background').on('click', () => {
                    modal.removeClass('active')
                })
            }
        })
    },
    verticalLineEffect() {
        $('.vertical-line-animation').each(function () {
            const sectionTarget = $(this).find('.heading-wrapper')
            const sectionOffsetTop = $(this).find('.heading-wrapper').offset().top + 500
            const sectionOffsetBottom = sectionOffsetTop + $(this).outerHeight()
            $(window).scroll(() => {
                const scrollPos = $(window).scrollTop()
                const windowHeight = $(window).height()
                const windowBottom = scrollPos + windowHeight

                if (windowBottom > sectionOffsetTop && scrollPos < sectionOffsetBottom) {
                    sectionTarget.addClass('is-active')
                } else {
                    sectionTarget.removeClass('is-active')
                }
            })
        })
    },
    singleVideo() {
        $('.single-video-block').each(() => {
            gsap.registerPlugin(ScrollTrigger)

            ScrollTrigger.create({
                trigger: '.single-video-block',
                start: 'top center',
                end: 'bottom center', // Adjusted to trigger leave earlier
                onEnter: () => {
                    // Lock screen scroll
                    $('body').css('overflow', 'hidden')

                    // Animate the section to expand full width and remove border radius
                    gsap.to('.single-video-block', {
                        duration: 1,
                        padding: 0,
                        onComplete: () => {
                            // Unlock screen scroll after animation
                            $('body').css('overflow', 'auto')
                        },
                    })

                    // Remove border radius of .video-wrapper
                    gsap.to('.video-wrapper', {
                        duration: 1,
                        borderRadius: 0,
                    })
                },
                onLeaveBack: () => {
                    // Lock screen scroll
                    $('body').css('overflow', 'hidden')

                    // Determine padding based on screen size
                    const paddingValue = window.innerWidth < 1024 ? '20px' : '40px'

                    // Animate the section to restore padding and border radius
                    gsap.to('.single-video-block', {
                        duration: 1,
                        padding: paddingValue,
                        onComplete: () => {
                            // Unlock screen scroll after animation
                            $('body').css('overflow', 'auto')
                        },
                    })

                    // Restore border radius of .video-wrapper
                    gsap.to('.video-wrapper', {
                        duration: 1,
                        borderRadius: '10px', // Assuming the original border radius is 10px
                    })
                },
            })
        })
    },
    hozaccordion() {
        $('.vertical-block').each(function () {
            const hozLi = $(this).find('.hoz-accordion li')
            hozLi.each(function () {
                const trigger = $(this).find('.tab-title')
                $(trigger).click(function (e) {
                    e.preventDefault()
                    const target = $(this).closest('li')
                    if (!target.hasClass('is-active')) {
                        hozLi.removeClass('is-active')
                        hozLi.removeClass('is-active')
                        $(target).addClass('is-active')
                    } else if ($(window).width() < 1088) {
                        $(target).removeClass('is-active')
                    }
                })
            })
        })
        $('.tiles-block').each(function () {
            const hozLi = $(this).find('.hoz-accordion li')
            hozLi.each(function () {
                const trigger = $(this).find('.tab-title')
                $(trigger).click(function (e) {
                    e.preventDefault()
                    const target = $(this).closest('li')
                    if (!target.hasClass('is-active')) {
                        hozLi.removeClass('is-active')
                        hozLi.removeClass('is-active')
                        $(target).addClass('is-active')
                    } else if ($(window).width() < 1088) {
                        $(target).removeClass('is-active')
                    }
                })
            })
        })
    },
    animatedIconsBgChange() {
        $('.fullwidth-image-animated-icons-block').each(function () {
            const $imageWrapper = $(this).find('.image-wrapper')
            const initialBackgroundImage = $imageWrapper.css('background-image')

            $(this)
                .find('.animated-slide')
                .on('mouseenter', function () {
                    const bgImg = $(this).find('.animated-slide-hidden').attr('data-bg-img')
                    $imageWrapper.css('background-image', `url(${bgImg})`)
                })

            $(this)
                .find('.animated-slide')
                .on('mouseleave', () => {
                    $imageWrapper.css('background-image', initialBackgroundImage)
                })
        })
    },
    horizontalScrollTiles() {
        $('section.horizontal-scroll-tiles-block').each(() => {
            $(document).ready(function () {
                const $tileWrapper = $(this).find('.tiles-wrapper')

                $('.video-tile').on('click', function () {
                    $(this).find('.play-video-btn').click()
                })

                function handleResize() {
                    $('.tile').off('mouseenter mouseleave') // Remove previous event handlers
                    $('.tile').on('mouseenter', function () {
                        if ($(window).width() > 1024) {
                            $(this).find('.content-hidden:not(.is-active-small)').addClass('is-active')
                            $(this).find('.mobile-tile-toggle').addClass('is-active')
                        }
                    })
                    $('.tile').on('mouseleave', function () {
                        if ($(window).width() > 1023) {
                            $(this).find('.content-hidden:not(.is-active-small)').removeClass('is-active')
                            $(this).find('.mobile-tile-toggle').removeClass('is-active')
                        }
                    })
                    $('.tile').find('.mobile-tile-toggle').off('click') // Remove previous event handlers
                    $('.tile')
                        .find('.mobile-tile-toggle')
                        .on('click', function () {
                            if ($(window).width() <= 1023) {
                                $tileWrapper.find('.tile').removeClass('is-hovered')
                                $tileWrapper.find('.tile .content-hidden').removeClass('is-active')
                                if ($(this).hasClass('is-active')) {
                                    $(this)
                                        .closest('.tile')
                                        .removeClass('is-hovered')
                                        .find('.content-hidden')
                                        .removeClass('is-active') // Remove the 'is-active' class
                                    $(this).removeClass('is-active')
                                } else {
                                    $tileWrapper.find('.tile .mobile-tile-toggle').removeClass('is-active')
                                    $(this)
                                        .closest('.tile')
                                        .addClass('is-hovered')
                                        .find('.content-hidden')
                                        .addClass('is-active')
                                    $(this).addClass('is-active')
                                }
                            }
                        })
                }

                handleResize() // Call on document ready

                $(window).resize(() => {
                    handleResize() // Call on window resize
                })
            })

            gsap.registerPlugin(ScrollTrigger)

            ScrollTrigger.matchMedia({
                '(min-width: 1024px)': function () {
                    const duration = 50
                    const sections = gsap.utils.toArray('.panel')
                    const sectionsLast = gsap.utils.toArray('.panel-last')
                    const sectionsBig = gsap.utils.toArray('.big-tile')
                    const sectionsAnim = gsap.utils.toArray('.panel:not(.panel-last')
                    const sectionIncrement = duration / (sections.length - 1)
                    const tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: '.horizontal-scroll-tiles-block',
                            pin: true,
                            normalizeScroll: true,
                            markers: false,
                            scrub: 1,
                            start: 'top top',
                            end: `+=${window.innerHeight * 4}`,
                            endTrigger: '.panel-last',
                            // anticipatePin: 1,
                            toggleClass: {
                                targets: '.pin-spacer',
                                className: 'is-active',
                            },
                            // end: '+=5000',
                        },
                    })

                    // const rightEdgePosition = $('.panel-last').offset().left + $('.panel-last').outerWidth()
                    const rightEdgePosition = $('.panel-last').offset().left

                    tl.to(sections, {
                        // x: -100 * (sections.length + 12),
                        x: () => window.innerWidth - rightEdgePosition - 400,
                        duration,
                        ease: 'none',
                    })

                    function handleActiveClass(sectionTime) {
                        const index = Math.round(sectionTime / sectionIncrement)
                        $('.panel-nav').removeClass('is-active') // Remove active class from all links
                        $('.panel-nav').eq(index).addClass('is-active') // Add active class to the corresponding link
                    }

                    // helper function that lets us define a section in a timeline that spans between two times (start/end) and lets us add onEnter/onLeave/onEnterBack/onLeaveBack callbacks
                    function addSectionCallbacks(
                        timeline,
                        { start, end, param, onEnter, onLeave, onEnterBack, onLeaveBack }
                    ) {
                        const trackDirection = (animation) => {
                            // just adds a "direction" property to the animation that tracks the moment-by-moment playback direction (1 = forward, -1 = backward)
                            const onUpdate = animation.eventCallback('onUpdate') // in case it already has an onUpdate
                            let prevTime = animation.time()
                            animation.direction = animation.reversed() ? -1 : 1
                            animation.eventCallback('onUpdate', () => {
                                const time = animation.time()
                                if (prevTime !== time) {
                                    animation.direction = time < prevTime ? -1 : 1
                                    prevTime = time
                                }
                                if (onUpdate) {
                                    onUpdate.call(animation)
                                }
                            })
                        }
                        const empty = (v) => v // in case one of the callbacks isn't defined
                        if (!timeline.direction) {
                            trackDirection(timeline)
                        } // make sure direction tracking is enabled on the timeline
                        if (start >= 0) {
                            timeline.add(() => {
                                if (timeline.direction < 0) {
                                    if (onLeaveBack) {
                                        onLeaveBack(param)
                                    }
                                } else {
                                    if (onEnter) {
                                        onEnter(param)
                                    }
                                }
                                handleActiveClass(start)
                            }, start)
                        }

                        if (end <= timeline.duration()) {
                            timeline.add(() => {
                                if (timeline.direction < 0) {
                                    if (onEnterBack) {
                                        onEnterBack(param)
                                    }
                                } else {
                                    if (onLeave) {
                                        onLeave(param)
                                    }
                                }
                                handleActiveClass(end)
                            }, end)
                        }
                    }

                    sections.forEach((section, index) => {
                        addSectionCallbacks(tl, {
                            start: sectionIncrement * (index - 0.99),
                            end: sectionIncrement * (index + 0.99),
                            onEnter: () => {
                                section.classList.add('active') // Add active class
                            },
                            onLeave: () => {
                                section.classList.remove('active') // Remove active class
                            },
                            onEnterBack: () => {
                                section.classList.add('active') // Add active class
                            },
                            onLeaveBack: () => {
                                section.classList.remove('active') // Remove active class
                            },
                        })
                    })

                    ScrollTrigger.create({
                        trigger: '.horizontal-scroll-tiles-block',
                        start: 'top center',
                        end: 'bottom bottom',
                        markers: false,
                    })
                    // Last panel animation
                    ScrollTrigger.create({
                        trigger: '.panel-last',
                        containerAnimation: tl,
                        start: 'center 110%',
                        end: 'center 5%',
                        markers: false,
                        toggleClass: {
                            targets: '.horizontal-scroll-tiles-block',
                            className: 'panel-last',
                        },
                    })

                    gsap.to('progress', {
                        value: 100,
                        ease: 'none',
                        scrollTrigger: { scrub: 0.3 },
                    })
                },
            })
        })
    },

    newsEvents() {
        let removedSlides = []
        // Function to restore removed slides
        function restoreSlides() {
            removedSlides.forEach((slide) => {
                $('.news-and-events-block .slick-wrapper').slick('slickAdd', slide)
            })
            removedSlides = []
        }

        $('.news-and-events-block .view-all-btn').on('click', function (e) {
            const target = $(this).attr('data-target')
            const buttonText = $(this).text() === 'View All' ? 'News' : $(this).text()
            $('.view-more-btn .entry-type').text(buttonText)

            if (!$(this).hasClass('is-active')) {
                $('.news-and-events-block .view-all-btn').removeClass('is-active')
                $(this).addClass('is-active')

                switch (target) {
                    case 'news-tile':
                        restoreSlides()
                        $('.news-and-events-block .slick-wrapper').slick('refresh')
                        $('.events-tile').each(function () {
                            const index = $(this).parent().parent().data('slick-index')
                            removedSlides.push($(this).parent().parent().clone())
                            $('.news-and-events-block .slick-wrapper').slick('slickRemove', index)
                        })
                        break
                    case 'events-tile':
                        restoreSlides()
                        $('.news-and-events-block .slick-wrapper').slick('refresh')
                        $('.news-tile').each(function () {
                            const index = $(this).parent().parent().data('slick-index')
                            removedSlides.push($(this).parent().parent().clone())
                            $('.news-and-events-block .slick-wrapper').slick('slickRemove', index)
                        })
                        break
                    default:
                        restoreSlides()
                        $('.news-and-events-block .slick-wrapper').slick('refresh')
                }
            }
        })
    },
    staffDirectory() {
        $('.staff-directory-block').each(() => {
            $('.view-staff-modal').on('click', function (e) {
                e.preventDefault()
                const modal = $(this).next()
                if (!modal) return
                digistormWeb.lockBg()
                modal.addClass('is-active')
            })
            $('.staff-modal .close-modal, .staff-modal .modal-background').click(function (e) {
                e.preventDefault()
                const $modal = $(this).find('.staff-modal')
                digistormWeb.unlockBg()
                $('.staff-modal').removeClass('is-active')
            })
        })
    },
    pallaraxContents() {
        $('section.call-out-block').each(() => {
            // Parallax effect
            const rellax = new Rellax('.rellax', {
                speed: -1,
                center: true,
            })
        })
    },
}

function initWebsiteScripts() {
    digistormWeb.init()
    $('body').addClass('animated-wowo-control')
}

// wait for vue to mount before attaching event listeners
// any event listeners attached before vue mounts will get deleted
document.addEventListener('ds-components-mounted', (e) => {
    initWebsiteScripts()
})

if (window.dsComponentsMounted) {
    initWebsiteScripts()
}

$(window).scroll(() => {
    digistormWeb.wowo()
})

$(window).on('load', () => {
    digistormWeb.wowo()
})
